import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MaterialRequirementsDto } from './models/material-requirements.dto';

@Injectable({ providedIn: 'root' })
export class MaterialRequirementsProvider {
  constructor(private http: HttpClient) {}

  /** from and to are calendar days ("2026-10-24"), both inclusive — no instants, no zone. */
  getMaterialRequirements(from: string, to: string): Observable<MaterialRequirementsDto> {
    const url = '/api/production/material-requirements';
    return this.http.get<MaterialRequirementsDto>(url, { params: { from, to } });
  }

  /**
   * The same range as an .xlsx workbook; timeZone (an IANA id) only stamps the file and its
   * name. The whole response, so the file name can be read from Content-Disposition (0107).
   */
  exportMaterialRequirements(from: string, to: string, timeZone: string): Observable<HttpResponse<Blob>> {
    const url = '/api/production/material-requirements/export';
    return this.http.get(url, { params: { from, to, timeZone }, responseType: 'blob', observe: 'response' });
  }
}
